export const applyPagination = ( data: any[], page: number, limit: number ): any[] => {
    return data.slice(page * limit, page * limit + limit);
  };